import { isHostNameMainDomain } from './customPage'

const hooks = {
  before: (request, state) => {
    if (request.url.match(/^\/api/)) {
      request.url = isHostNameMainDomain()
        ? `${process.env.REACT_APP_API_SUB_DOMAIN_SERVER}${request.url}`
        : `${process.env.REACT_APP_API_SERVER}${request.url}`
    }

    const token = isHostNameMainDomain() ? state.customPage.token : state.authentication.token

    if (typeof request.headers.Authorization !== 'undefined') {
      request.headers.Authorization = `Bearer ${token}`
    } else if (typeof request.headers.get === 'function' && request.headers.get('Authorization') !== null) {
      request.headers.set('Authorization', `Bearer ${token}`)
    }
  },
}

export default hooks
